import { imageUrl } from '@helpers/image';
import { responsiveSizes } from '@helpers/responsive';
import LinkButton from '@stories/Components/Buttons/LinkButton/LinkButton';
import React from 'react';
import S from './CtaCard.styles';
const CtaCard = ({ bgImage, useBothImages = false, makeFullWidth = false, content, email, fgImage, title, cta, ctaTheme, }) => {
    return (React.createElement(S.Container, { "data-is-boxed": useBothImages, flush: makeFullWidth ? 'bottom' : 'none' },
        bgImage && makeFullWidth && (React.createElement(S.BgImage, { alt: bgImage.altText, draggable: false, loading: "lazy", role: "presentation", src: imageUrl(bgImage, {}), sizes: [`100vw`].join(', '), srcSet: responsiveSizes([{ value: 100 }], bgImage, {
                heightRatio: 301 / 820,
                mode: 'crop',
            }) })),
        React.createElement(S.Inner, null,
            bgImage && !makeFullWidth && (React.createElement(S.BgImage, { alt: bgImage.altText, draggable: false, loading: "lazy", role: "presentation", src: imageUrl(bgImage, {}), sizes: [`100vw`].join(', '), srcSet: responsiveSizes([{ value: 100 }], bgImage, {
                    heightRatio: 301 / 820,
                    mode: 'crop',
                }) })),
            fgImage && (React.createElement(S.ImageWrapper, null,
                React.createElement(S.FgImage, { alt: fgImage.altText, draggable: false, loading: "lazy", src: imageUrl(fgImage, {}), sizes: [`100vw`].join(', '), srcSet: responsiveSizes([{ value: 100 }], fgImage, {
                        heightRatio: 433 / 637,
                        mode: 'pad',
                    }) }))),
            React.createElement(S.ContentWrapper, null,
                React.createElement(S.Title, null, title),
                React.createElement(S.Content, { dangerouslySetInnerHTML: { __html: content } }),
                React.createElement(S.LinkArea, null,
                    email && (React.createElement(S.EmailArea, { href: `mailto:${email}` },
                        React.createElement(S.MailIcon, null),
                        React.createElement(S.EmailContent, null, email))),
                    cta?.text && (React.createElement(S.CtaWrapper, null,
                        React.createElement(LinkButton, { themeOption: ctaTheme, href: cta?.url, target: cta?.target, title: cta?.text }))))))));
};
export default CtaCard;
